/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Text } from 'hocs/localization'
import { toCurrency } from 'utils/price'
import * as styles from './SelectedPlan.scss'
import logo from 'assets/images/logo.png'

interface IProps {
  t: Text,
  plan: any,
}

const SelectedPlan: React.SFC<IProps> = ({ plan = {}, t }) => (
  <div className='col-md-12'>
    <div className={styles.Content}>
      <div className={styles.leftImg}><img src={plan.imageUri} alt={plan.name}/></div>
      <div className={styles.rightside}>
        <p><div>{plan.name} {t('plan')}</div>
        <div>{plan.productDescription} {t('printer')}</div>
        <div>{t('with')} <span className={styles.boldText}>{t('unlimited')}</span></div>
        <div><span className={styles.boldText}>{t('automat')}</span></div>
        </p>
        <div>
          <span className={styles.price}> {t('price', { price: toCurrency(plan.price) })} </span>
          <span className={styles.fee}>{t('taxes')}</span>
        </div>
        <h2>
          {!!plan.activationFee && (
            <div className={styles.fee}>
              {t('activationFee', { activationFee: toCurrency(plan.activationFee) })}
            </div>
          )}
        </h2>
        <div className={styles.allRightImgs}>
          <div className={styles.rightImg1}><img src={plan.productImageUri} alt={plan.productDescription}/></div>
          <div className={styles.rightImg2} ><img src={logo} /></div>
        </div>
      </div>
    </div>
  </div>
)

export default SelectedPlan
